.actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.actionIconButton {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}
